import { App } from 'antd';
import { SITE } from 'config/config';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

/** Mở dự đoán World Cup 2026: 01/06/2026 00:00:00 (giờ Việt Nam, UTC+7) */
const WC2026_PREDICTION_OPENS_AT = new Date('2026-06-01T00:00:00+07:00');
const WC2026_PREDICTION_URL = 'https://f8bet-dudoan-wc2026.pages.dev/';

const ASSETS = {
  bgItem: '/assets/images/home/bg_item.png',
  imgDdts: '/assets/images/home/img_ddts.png',
  btnDdts: '/assets/images/home/btn_ddts.png',
  imgDdwc: '/assets/images/home/img_ddwc.png',
  btnDdwc: '/assets/images/home/btn_ddwc.png',
  linhvat: '/assets/images/home/linhvat.gif',
  bottomLeft: '/assets/images/home/bottom_left.png',
  bottomRight: '/assets/images/home/bottom_right.png',
  bong: '/assets/images/home/bong.gif'
};

const itemPanelBtnClass =
  'relative z-[3] flex w-full max-w-[240px] items-center justify-center transition-transform duration-200 hover:scale-105 active:scale-95';

const ItemPanel = ({ to, externalHref, opensAt, imgTop, imgBtn, imgTopAlt, imgBtnAlt }) => {
  const { notification } = App.useApp();

  const btnImg = (
    <img src={imgBtn} alt={imgBtnAlt} className="h-auto w-full object-contain" draggable={false} />
  );

  const action =
    externalHref != null ? (
      <a
        href={externalHref}
        target="_blank"
        rel="noopener noreferrer"
        className={itemPanelBtnClass}
        onClick={(e) => {
          if (opensAt != null && Date.now() < opensAt.getTime()) {
            e.preventDefault();
            notification.warning({
              message: 'Thông báo',
              description: 'Chưa đến thời gian dự đoán.'
            });
          }
        }}
      >
        {btnImg}
      </a>
    ) : (
      <Link to={to} className={itemPanelBtnClass}>
        {btnImg}
      </Link>
    );

  return (
    <div className="relative isolate flex min-h-[380px] w-[85%] max-w-[380px] flex-col items-center justify-start py-4 md:min-h-[420px] md:max-w-[400px]">
      <div className="relative z-[2] flex w-full flex-col items-center gap-3 px-2">
        {/* Tâm bg_item trùng tâm imgTop: khung chỉ ôm ảnh trên */}
        <div className="relative mx-auto w-full max-w-[480px] origin-center scale-[1.35] md:scale-100">
          <div
            className="pointer-events-none absolute left-1/2 top-1/2 z-[1] flex w-[min(108%,480px)] max-w-[480px] -translate-x-1/2 -translate-y-1/2 justify-center"
            aria-hidden
          >
            <div className="aspect-square w-full">
              <img
                src={ASSETS.bgItem}
                alt=""
                className="h-full w-full origin-center select-none object-contain object-center animate-spin-cw"
              />
            </div>
          </div>
          <img
            src={imgTop}
            alt={imgTopAlt}
            className="relative z-[2] w-full object-contain"
            draggable={false}
          />
        </div>
        {action}
      </div>
    </div>
  );
};

const HomePage = () => {
  return (
    <div className={twMerge(SITE, 'relative isolate h-full w-full min-h-screen')}>
      {/* Background Image */}
      <img
        src="/assets/images/home/bg.png"
        alt="Background"
        className="fixed bottom-0 right-0 h-full w-full object-cover object-center"
      />

      <img
        src={ASSETS.bottomLeft}
        alt=""
        aria-hidden
        className="pointer-events-none absolute bottom-0 left-0 z-[5] max-h-[min(28vh,200px)] w-auto max-w-[min(50vw,360px)] select-none object-contain object-left-bottom md:max-h-[min(32vh,280px)] md:max-w-[420px] lg:max-h-[min(38vh,360px)] lg:max-w-[min(42vw,560px)]"
        draggable={false}
      />
      <img
        src={ASSETS.bottomRight}
        alt=""
        aria-hidden
        className="pointer-events-none absolute bottom-0 right-0 z-[5] max-h-[min(28vh,200px)] w-auto max-w-[min(50vw,360px)] select-none object-contain object-right-bottom md:max-h-[min(32vh,280px)] md:max-w-[420px] lg:max-h-[min(38vh,360px)] lg:max-w-[min(42vw,560px)]"
        draggable={false}
      />
      <img
        src={ASSETS.bong}
        alt=""
        aria-hidden
        className="pointer-events-none absolute bottom-0 left-1/2 z-[5] max-h-[min(20vh,120px)] w-auto -translate-x-1/2 select-none object-contain object-bottom md:max-h-[min(24vh,160px)] lg:max-h-[200px]"
        draggable={false}
      />

      {/* Main Content Container */}
      <div className="relative z-10 flex w-full flex-col items-center">
        {/* <Header /> */}
        <div className="flex w-full justify-center px-4 pt-4 md:pt-6">
          <img
            src="/assets/images/home/logo_title.png"
            alt="F8BET dự đoán"
            className="h-[95px] md:h-[135px] w-auto max-w-full object-contain"
          />
        </div>

        {/* Main Content Area */}
        <div className="mt-12 md:mt-0 flex flex-col items-center justify-center px-4 py-2">
          <div className="mx-auto w-full max-w-[1600px] justify-items-center gap-y-10 px-2 flex flex-row md:items-end md:gap-y-0 md:gap-x-4 md:px-4 lg:gap-x-8">
            <div className="flex w-full justify-center md:justify-end">
              <ItemPanel
                to="/sport"
                imgTop={ASSETS.imgDdts}
                imgBtn={ASSETS.btnDdts}
                imgTopAlt="Dự đoán tỷ số thể thao"
                imgBtnAlt="Vào dự đoán thể thao"
              />
            </div>
            <div className="hidden md:flex w-full max-w-[420px] flex-col items-center justify-end md:max-w-[500px] lg:max-w-[704px]">
              <img
                src={ASSETS.linhvat}
                alt="Linh vật"
                className="h-full w-auto max-h-[336px] object-contain object-center select-none md:max-h-[400px] lg:max-h-[566px]"
                draggable={false}
              />
            </div>
            <div className="flex w-full justify-center md:justify-start">
              <ItemPanel
                externalHref={WC2026_PREDICTION_URL}
                // opensAt={WC2026_PREDICTION_OPENS_AT}
                imgTop={ASSETS.imgDdwc}
                imgBtn={ASSETS.btnDdwc}
                imgTopAlt="Dự đoán World Cup"
                imgBtnAlt="Vào dự đoán World Cup 2026"
              />
            </div>
          </div>
          <div className="flex md:hidden w-full max-w-[420px] -mt-[200px] md:mt-0 flex-col items-center justify-end md:max-w-[500px] lg:max-w-[704px]">
            <img
              src={ASSETS.linhvat}
              alt="Linh vật"
              className="h-auto w-full max-h-[356px] object-contain object-bottom select-none md:max-h-[400px] lg:max-h-[566px]"
              draggable={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
